import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { openReviewsGoToAppModal } from 'shared/actions/reviewsGoToAppModal';
import { CardSectionNew } from 'shared/components/CardSectionNew';
import { ReviewsSnippet } from 'shared/components/ReviewsSnippet';
import { reviewsElementId } from 'shared/constants/reviews';
import { useApplicationContext } from 'shared/containers/ApplicationContext';
import { trackGoToNewReview } from 'shared/containers/ReviewsSnippetContainer/utils/trackGoToNewReview';
import { useDailyRentReviews } from 'shared/hooks/useReviewsMiniWidget';
import { selectOfferId } from 'shared/selectors';
import { selectRatingDetails } from 'shared/selectors/dailyrentData/selectRatingDetails';
import { extractNumber } from 'shared/utils/extractNumber';

import { trackGoToReviewsPage } from './utils';

export function ReviewsSnippetContainer() {
  const dispatch = useDispatch();
  const { config } = useApplicationContext();
  const isCreateReviewEnabled = config.get<boolean>('Dailyrent.CreateReview.Enabled') || false;
  const objectId = useSelector(selectOfferId);
  const ratingDetails = useSelector(selectRatingDetails);
  const { ratingValue, reviewCount, scores, viewAllReviewsButtonUrl, writeReviewButtonUrl } = ratingDetails ?? {};
  const { isReviewsEnabled } = useDailyRentReviews();
  const rating = ratingValue ? extractNumber(ratingValue) : -1;
  const reviewsCount = reviewCount ? extractNumber(reviewCount) : -1;

  const onShowAllReviewsClick = React.useCallback(() => {
    trackGoToReviewsPage({ objectId, rating, reviewsCount });
  }, [objectId, rating, reviewsCount]);

  const onWriteButtonClick = React.useCallback(
    (event: React.MouseEvent<HTMLAnchorElement>) => {
      if (isCreateReviewEnabled) {
        trackGoToNewReview({ objectId, rating, reviewsCount });

        return;
      }

      event?.preventDefault();
      dispatch(openReviewsGoToAppModal());
    },
    [dispatch, isCreateReviewEnabled, objectId, rating, reviewsCount],
  );

  // Вместо пустого состояния - null
  if (!isReviewsEnabled || (!ratingValue && !reviewCount)) {
    return null;
  }

  return (
    <CardSectionNew>
      <ReviewsSnippet
        elementId={reviewsElementId}
        rating={ratingValue}
        reviewsCount={reviewCount}
        writeLink={writeReviewButtonUrl}
        reviewsLink={viewAllReviewsButtonUrl}
        scores={scores}
        onAllButtonClick={onShowAllReviewsClick}
        onWriteButtonClick={onWriteButtonClick}
      />
    </CardSectionNew>
  );
}
